<template>
  <div
    class="bg-full vw-100 vh-100 flex-column d-flex justify-content-start align-items-center overflow-auto position-relative"
  >
    <img
      src="../assets/images/active-health.png"
      alt="active-health"
      class="invisible-image position-absolute top-0 left-0 mt-2 cursor-pointer"
      width="180px"
      @click="logout()"
    />

    <section class="card-section" v-if="showTouchStart">
      <div class="card-box">
        <div class="card-box-inner">
          <img src="../assets/images/mansitting.jpg" alt="" />
          <h2>Sit-to-Stand Test</h2>
          <div class="card-box-btn">
            <button class="btn"  @click="handleTouchToStart"><span>Touch to Start</span></button>
          </div>
        </div>
      </div>
      <div class="card-bottom-content">
        <p>
          Try out the Sit-to-Stand Test to find out more about your lower body
          muscular strength and endurance.
        </p>
      </div>
    </section>

    <div v-if="!showDemo && !showTouchStart" class="responsive-width">

    
    <label
      class="position-absolute text-center text-white font-weight-bold right-0 top-0 mt-2 mr-2 font-26"
      >Powered by<br />
      EliteFit.AI</label
    >
    <h1 class="text-black font-80 mb-2 text-center ">Welcome!</h1>
    <label class="text-black font-40 font-weight-400 mb-5 text-center d-block">Are you ready to start?</label>
    <div
      class="w-100 d-flex flex-column justify-content-center align-items-center"
    >
      <div class="video mb-5 videoiframe">
        <video
        src="https://s3.ap-southeast-1.amazonaws.com/www.elitefit.ai/videos/sit-to-stand-teaser-video.mp4"
        ref="youtubeIntro"
        width="100%"
        height="100%"
        class="rounded"
        autoplay
        @ended="introVideoEnd()"
      ></video>
      </div>
      

    </div>
    <div class="mt-auto text-center">
    <div
        class="px-5 py-2 bg-brown text-white d-inline-flex justify-content-center cursor-pointer align-items-center font-26 font-weight-600 mt-auto"
        @click="showDemo = !showDemo"
      >
        Start
      </div>
      </div>
  </div>
    <div v-else-if="showDemo && !showTouchStart" class="w-100 h-100 position-absolute">
      <div class="w-100 h-100 bg-black">
        <video
        src="https://s3.ap-southeast-1.amazonaws.com/www.elitefit.ai/videos/sit-to-stand-demo-video.mp4"
        ref="youtube"
        width="100%"
        height="100%"
        class="rounded"
        autoplay
        @ended="instructionVideoEnd()"
      ></video>
        <div
          class="w-auto h-auto position-absolute top-45 right-0 bg-black z-index-top px-3 py-1 mr-2 font-36 cursor-pointer text-white rounded"
          v-if="showDemo"
          @click="skipPage()"
        >
          SKIP
        </div>
      </div>
    </div>
    <div class="mt-auto">
    
    <img
      src="../assets/images/better-beats-perfect.png"
      alt="active-health"
      class="mb-2 pt-3 mt-auto"
      width="200px"
    />
    </div>
   <b-modal
      id="change-camera"
      class="text-light"
      size="sm"
      hide-footer
    >
      <div class="camera-modal">
        <b-form-group class="border-0">
          <div class="camera-select-label">
            CAMERA
            <div id="show-camera-optional" class="i-border ml-1">
              <b-tooltip
                custom-class="custom-tooltip"
                target="show-camera-optional"
                title="Tooltip title"
              >
                Select a camera.
              </b-tooltip>
              <span class="info-icon notranslate">i</span>
            </div>
          </div>
          <b-form-select
            v-model="selectedWebCam"
            :options="availableWebCams"
            class="float-left"
            size="sm"
            text-field="label"
            value-field="deviceId"
          ></b-form-select>
        </b-form-group>
        <camera-access-helper
          ref="cameraHelper"
          style="pointer-events: auto"
        ></camera-access-helper>
        <div class="bottom-msg-container">
          <div v-if="cameraLoadError" class="camera-loading-error">
            There was an error. Please make sure you have provided camera
            access.
            <svg
              aria-hidden="true"
              class="info-svg"
              color="#9e9e9e"
              data-icon="info-circle"
              data-prefix="fas"
              focusable="false"
              role="img"
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
              @click="$refs.cameraHelper.open"
            >
              <path
                d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
                fill="currentColor"
              />
            </svg>
          </div>
        </div>
        <video 
          v-show="activeWebCam"
          ref="videoRef"
          autoplay
          class="video-container"
          crossorigin="anonymous"
          muted
          playsinline
          style="z-index: 0"
          :style='{aspectRatio : webCamAspectRatio}'
        ></video>
      </div>
    </b-modal>
    <div class="camera-gear-icon cursor-pointer" @dblclick="changeCamera">
      <b-icon icon="gear"></b-icon>
    </div>
  </div>
</template>
<script>
import CameraAccessHelper from "@/module_user/views/CameraAccessHelper";
export default {
  name: "IntroPageView",
  components: {
    CameraAccessHelper
  },
  data: function() {
    return {
      showTouchStart:true,
      showDemo: false,
      playerVars: {
        autoplay: 1,
        controls: 1,
        playsinline: 1,
        loop: 1,
        mute: 1,
      },
      availableWebCams: [],
      cameraLoadError: null,
      webCamAspectRatio : 16/9,
      activeWebCam : null
    };
  },
  methods: {
    handleTouchToStart(){
      this.showTouchStart = !this.showTouchStart;
      // For now, directly redirecting the user to safety precautions page on click
      // this.skipPage();
    },
    skipPage() {
      this.$router.push({ name: "safety-precautions" });
    },
    introVideoEnd() {
      if (this.$refs.youtubeIntro) {
        this.$refs.youtubeIntro.currentTime = 0;
        this.$refs.youtubeIntro.play();
      }
    },
    instructionVideoEnd() {
      this.skipPage();
    },
    logout() {
      const result = confirm("If you want to logout?")
      if(result){
        const loginFrom = localStorage.getItem('ssgLoginFrom');
        localStorage.removeItem('ssgLoginFrom');
        localStorage.removeItem("login");
        this.$router.push({ path: `/${loginFrom}` });
      }
    },
    async changeCamera() {
      this.$root.$emit('bv::show::modal', 'change-camera');
      this.availableWebCams = await this.listWebCams();
      let deviceId = localStorage.getItem('default_camera')
      if(deviceId && deviceId === this.selectedWebCam){
        this.loadWebCam(deviceId);
        return
      }

      if(!deviceId && this.availableWebCams.length > 0){
        deviceId = this.availableWebCams[0].deviceId
      }
      if(this.availableWebCams.length > 0 && !this.availableWebCams.find(cam=> cam.deviceId === deviceId)){
        deviceId = this.availableWebCams[0].deviceId

      }
      this.selectedWebCam = deviceId
    },
    loadWebCam(deviceId) {
      let constraints = {audio: false, video: {deviceId: {exact: deviceId}}};
      return navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
        this.$refs.videoRef.srcObject = stream;
      }).catch(error => {
        this.cameraLoadError = error;
        return error;
      });
    },
    onWebCamChange() {
      const webCamEl = this.$refs.videoRef;
      const {deviceId} = webCamEl.srcObject?.getVideoTracks()[0].getSettings();
      if (deviceId && deviceId != this.activeWebCam) this.activeWebCam = deviceId;
      this.changeWebCamDims();
    },
    async listWebCams() {
      const _ = await navigator.mediaDevices.getUserMedia({ audio: false, video: true });
      const deviceInfos = await navigator.mediaDevices.enumerateDevices();
      return deviceInfos.map(info => {
        return {
        deviceId: info.deviceId,
        label: info.label,
        kind: info.kind,
      }}).filter(({ kind }) => kind === "videoinput");
    },

    changeWebCamDims() {
      const webCamEl = this.$refs.videoRef;
      if (webCamEl && webCamEl.readyState === webCamEl.HAVE_ENOUGH_DATA) {
        const settings = webCamEl.srcObject?.getVideoTracks()[0].getSettings();
        const {aspectRatio: webCamAspectRatio} = settings;
        this.webCamAspectRatio = webCamAspectRatio
      }
    },

    stopWebCam(stream) {
      let tracks = stream.getTracks();
      tracks.forEach(track => track.stop());
    },
  },
  computed :{
    selectedWebCam: {
      get() {
        return this.activeWebCam
      },
      set(deviceId) {
        if (deviceId === this.selectedWebCam) return;
        const stream = this.$refs.videoRef.srcObject;
        if (stream) this.stopWebCam(stream);
        if (deviceId) this.loadWebCam(deviceId)
        this.activeWebCam = deviceId
        localStorage.setItem('default_camera', deviceId)

      }
    },
  },
};
</script>
<style scoped>

.camera-gear-icon {
  position: fixed;
  bottom: 50px;
  right: 16px;
  z-index: 1;

  padding: 8px 24px;
  border-radius: 25px;
  font-size: 35px;
  font-weight: bold;
  line-height: 24px;
  text-align: center;
  border: 0;
  max-width: 400px;
  white-space: nowrap;

  display: flex;
  column-gap: 16px;
  align-items: center;
  color: transparent;

}

::v-deep  .modal-dialog{
    max-width: 500px !important;
    margin: 3rem auto 0 auto;
  }


.camera-modal{
  text-align: left;
  width: 100%;
  .camera-select-label {
    position: relative;
    color: #969b92;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 8px;
  }

  select {
    background: #ffffff;
    box-sizing: border-box;
    border-radius: 5px;
    height: 40px;
  }

  .video-container{
    width: 100%;
    max-height: 100%;
  }

  .camera-loading-error{
    svg{
      height: 25px;
    }
  }

}


.bg-full {
  background-image: url("../assets/images/EFS2SBackgroundNew.png");
}
.video {
  position: relative;
  width: 100% !important;
  height: auto;
  aspect-ratio: 16/9;
  /* padding-bottom: 56.25%; */
  background-color: black !important;
}
.invisible-image{
  opacity: 0;
}

body {
        background-color: #ffb850;
      }

      .card-section {
        padding: 60px 0px;
      }
      .card-box {
        position: relative;
        max-width: 316px;
        padding: 50px 20px 30px;
        margin: 0 auto;
      }
      .card-box::after {
        -moz-transform: skewX(-10deg) skewY(0deg);
        -webkit-transform: skewX(-10deg) skewY(0deg);
        -o-transform: skewX(-10deg) skewY(0deg);
        -ms-transform: skewX(-10deg) skewY(0deg);
        transform: skewX(-10deg) skewY(0deg);
        position: absolute;
        content: "";
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: #fff;
        box-shadow: 4px 9px 11px 0px #0000002e;
      }
      .card-box-inner {
        position: relative;
        z-index: 2;
      }
      .card-box img {
        width: 200px;
        max-width: 100%;
        display: block;
        margin: 0 auto 30px;
      }
      .card-box-inner h2 {
        color: #64656a;
        font-size: 30px;
        list-style: 30px;
        font-weight: 700;

        margin-left: -5%;
      }
      .card-box-btn .btn {
        background-color: #64656a;
        color: #fff;
        -moz-transform: skewX(-10deg) skewY(0deg);
        -webkit-transform: skewX(-10deg) skewY(0deg);
        -o-transform: skewX(-10deg) skewY(0deg);
        -ms-transform: skewX(-10deg) skewY(0deg);
        transform: skewX(-10deg) skewY(0deg);
        font-size: 20px;
        border-radius: 0;
        padding: 6px 20px;
      }
      .card-box-btn .btn span {
        -moz-transform: skewX(10deg) skewY(0deg);
        -webkit-transform: skewX(10deg) skewY(0deg);
        -o-transform: skewX(10deg) skewY(0deg);
        -ms-transform: skewX(10deg) skewY(0deg);
        transform: skewX(10deg) skewY(0deg);
        display: inline-block;
      }
      .card-box-btn {
        margin: 24px 0 20px 30px;
      }
      .card-bottom-content {
        padding-top: 30px;
        max-width: 900px;
        margin: 0 auto;
      }
      .card-bottom-content p {
        font-size: 22px;
        line-height: 32px;
        color: #000;
        font-weight: 700;
        text-align: center;
      }
      .bottom-text {
        font-size: 18px;
        font-weight: 500;
      }

      .videoiframe iframe{
        width: 500px !important;
        height: 300px;
      }

      .responsive-width{
        width: 45%;
      }

      @media screen and (max-width: 768px) {
        .responsive-width{
          width: 80%;
        }
      }
</style>
